import React from "react";
import { connect } from "react-redux";
import { selectBreadcrumbs } from "../../selectors";
import PropTypes from "prop-types";
import { Breadcrumb, ConfigProvider } from "antd";
import { Link } from "react-router-dom";

function Breadcrumbs({ nav }) {
  if (!nav || nav.length <= 1) return null;

  const items = nav.map((item, i) =>
    i === nav.length - 1
      ? { title: item[1] }
      : { title: <Link to={item[0]}>{item[1]}</Link> },
  );

  return (
    <ConfigProvider
      theme={{
        components: {
          Breadcrumb: {
            itemColor: "rgba(196, 196, 196, 0.69)",
            lastItemColor: "#fff",
            linkColor: "rgba(196, 196, 196, 0.69)",
            linkHoverColor: "#fff",
            separatorColor: "rgba(196, 196, 196, 0.69)",
            separatorMargin: 8,
          },
        },
      }}
    >
      <Breadcrumb items={items} />
    </ConfigProvider>
  );
}

Breadcrumbs.propTypes = { nav: PropTypes.array.isRequired };

export default connect((state) => ({
  nav: selectBreadcrumbs(state),
}))(Breadcrumbs);
